import { ReceiveCodeItemDelete } from '../action-types';
import { CodetableListState, CodeListBranch } from '../types-store';

export const mapToDecreasedChildrenCount = (state: CodetableListState, action: ReceiveCodeItemDelete): CodeListBranch[] =>
  decreaseChildrenCount(state.codeListBranch, action.codeId, undefined);

const decreaseChildrenCount = (codeListBranch: CodeListBranch[], codeId: number, childrenCount: number): CodeListBranch[] => {
  if (codeId === undefined) {
    return codeListBranch;
  }

  const sourceBranch = codeListBranch.find(branch => branch.items.find(item => item.id === codeId));
  const sourceItem = sourceBranch && sourceBranch.items.find(item => item.id === codeId);
  const sourceItemIndex = sourceBranch && sourceBranch.items.findIndex(item => item.id === codeId);

  if (!sourceItem) {
    return codeListBranch;
  }

  const resultItem = {
    ...sourceItem,
    childrenCount: childrenCount > 0 ? sourceItem.childrenCount - childrenCount : 0
  };

  const resultBranchWithoutSourceItem = sourceBranch.items.filter(item => item.id !== resultItem.id);

  const resultBranchItems = [...resultBranchWithoutSourceItem.slice(0, sourceItemIndex),
    resultItem,
  ...resultBranchWithoutSourceItem.slice(sourceItemIndex, resultBranchWithoutSourceItem.length)
  ];

  const resultBranch = {
    ...sourceBranch,
    items: resultBranchItems
  };

  const resultCodeListBranchWithoutResultBranch = codeListBranch.filter(branch => branch.id !== resultBranch.id);

  const resultCodeListBranch = [
    ...resultCodeListBranchWithoutResultBranch,
    resultBranch
  ];

  return decreaseChildrenCount(resultCodeListBranch, resultBranch.id, childrenCount || sourceItem.childrenCount + 1);
};
